import { Container, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ButtonContainer = styled(Container)(() => ({
  position: 'sticky',
  bottom: 0,
  background: '#fff',
  padding: '1rem',
  boxShadow: '0px -6px 20px -6px #0C62FB29;',
  display: 'flex',
  justifyContent: 'center',
  gap: '1rem',
  zIndex: 10,
}))

export const ButtonInnerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '342px',
  [theme.breakpoints.up('desktop')]: {
    maxWidth: '800px',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}))
